import React from "react"

const AppVersion = () => {
  return (
    <p className="absolute bottom-4 right-4">
      <span className="text-gray-700">version</span> -{" "}
      <span>{process.env.REACT_APP_VERSION}</span>
    </p>
  )
}

export default AppVersion
